import {
    DWT_PAYLOAD_REPORT_STATUS_CODES,
    DWT_PAYLOAD_STATUS_CODE_TO_FILTER_LABEL,
} from './dwt-payloads.constants';

/** Successful / Warnings / Errors — BE integers 2 / 3 (Retrying) / 4; all selected by default. */
export const DWT_PAYLOADS_STATUS_MULTISELECT_OPTIONS: readonly {
    value: string;
    label: string;
}[] = DWT_PAYLOAD_REPORT_STATUS_CODES.map((code) => ({
    value: String(code),
    label: DWT_PAYLOAD_STATUS_CODE_TO_FILTER_LABEL[code],
}));
